import React from 'react';
import { downloadProductImage } from '../../utils/productImageDownloader';
import '../../styles/productImageDownload.css';

/**
 * 產品縮圖右下角的「下載圖片」小圖示（需求 R152）。
 *
 * PM 2026-09-01 留言逐字：
 *   「1. 報價單-詳情頁（鎖住）、2. 產品管理、3. 型錄管理，都可以支援將滑鼠移到產品縮圖時，
 *     出現下載圖片按鈕，直接點擊則下載該產品圖片，並且下載結果與在產品詳細頁執行結果相同。」
 *
 * 「與產品詳細頁執行結果相同」＝本元件不自己實作任何下載行為，一律呼叫
 * utils/productImageDownloader.js 的 downloadProductImage()，那支就是從
 * ProductDetailPage.handleDownloadImage 整段搬出來的同一份程式碼（需求 R142）。
 * 檔名規則、CORS 退場、404／0 byte 防線因此四處完全一致。
 *
 * 三件必須留在**呼叫端之外**、由本元件自己保證的事：
 *   1) 無圖不渲染（src 為空字串／undefined 直接回 null）—— PM 的需求是「滑鼠移到產品縮圖」，
 *      「無圖片」佔位框上不該冒出一顆下載鈕。
 *   2) stopPropagation ＋ preventDefault：這顆鈕會被放進本身就可點的縮圖容器裡
 *      （產品管理批量修改／型錄批量編輯／報價單編輯頁的縮圖 onClick 是「點擊更換圖片」的
 *      檔案上傳），不擋住的話按一次下載會同時彈出檔案選擇視窗。
 *   3) type="button"：這些頁面有表單，預設的 submit 會誤送。
 *
 * 顯示／隱藏純由 styles/productImageDownload.css 的 hover 規則決定（呼叫端的容器要帶
 * .product-image-download-host）。本元件不接 hover state，避免每個縮圖各自 re-render。
 *
 * @param {string} src 產品圖片網址（productImage）
 * @param {string} productName 產品名稱（決定下載檔名）
 */
const ProductImageDownloadButton = ({ src, productName }) => {
  if (!src) return null;

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    downloadProductImage(src, productName);
  };

  return (
    <button
      type="button"
      className="product-image-download-btn"
      onClick={handleClick}
      title="下載這張產品圖片到電腦，檔名為產品名稱"
      aria-label="下載產品圖片"
    >
      {'⬇️'}
    </button>
  );
};

export default ProductImageDownloadButton;
